import { useEffect } from 'react';
import { useSubmit } from 'react-router-dom';

export function SignOutPage() {
  const submit = useSubmit();

  useEffect(() => {
    submit(null, { method: 'post', replace: true });
  }, [submit]);

  return <h1>Signing out...</h1>;
}
